import { createFileRoute } from "@tanstack/react-router";
import { AuthScreen } from "@/components/auth/auth-screen";
export const Route = createFileRoute("/auth/sign-in")({
  validateSearch: (search: Record<string, unknown>): { error?: string } => ({
    error: typeof search.error === "string" ? search.error : undefined,
  }),
  component: () => (
    <AuthScreen key="sign-in" mode="sign-in" oauthError={Route.useSearch().error} />
  ),
});
